import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { SingleImageDropzone } from "../DropzoneComponents";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BrandEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  const [settings, setSettings] = useState(null);

  const [form, setForm] = useState({
    title: "",
    status: "aktif",
    delete_image: false,
  });

  const [file, setFile] = useState(null);
  const [existingImage, setExistingImage] = useState("");

  /* ✅ Ayarları çek (brand width/height) */
  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSettings(res.data))
      .catch(() => toast.error(getText("SETTINGS_FETCH_ERROR")));

  }, []);

  /* ✅ Mevcut marka verisini çek */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/stock-brands/${id}`)
      .then((res) => {
        setForm({
          title: res.data.title,
          status: res.data.status,
          delete_image: false,
        });
        setExistingImage(res.data.image);
      });
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append("title", form.title);
    data.append("status", form.status);
    data.append("delete_image", form.delete_image ? "true" : "false");

    if (file) data.append("image", file);

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/stock-brands/${id}`,
        data,
      );
     toast.success(getText("BRAND_UPDATED_SUCCESS"));

      navigate("/brands/table");
    } catch {
      toast.error(getText("BRAND_UPDATED_ERROR"));
    }
  };

  return (
    <div className="container mt-4">
      <form className="card p-4" onSubmit={handleSubmit}>

        <label className="form-label fw-bold">  {getText("BRAND_NAME_LABEL")}</label>
        <input
          className="form-control mb-3"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
        />

        {/* ✅ Marka Logosu */}
        <label className="form-label fw-bold">
          {getText("BRAND_LOGO_LABEL")}  ({settings?.brand_image_width}x
          {settings?.brand_image_height})
        </label>

        {settings ? (
          <SingleImageDropzone
            fieldName="image"
            fieldValue={file || existingImage}
            setFieldValues={(fn) => {
              const val =
                typeof fn === "function" ? fn({ image: file }).image : fn.image;

              setFile(val || null);
              // eski resmi sil
              if (val && existingImage) {
                setExistingImage(null);
                setForm((prev) => ({ ...prev, delete_image: true }));
              }
            }}
            required={false}
            maxWidth={Number(settings.brand_image_width)}
            maxHeight={Number(settings.brand_image_height)}
          />
        ) : (
          <p>{getText("LOADING_SETTINGS")}</p>

        )}

        {/* ✅ Eski resim varsa göster ve sil */}
        {!file && existingImage && (
          <div className="mt-2">
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}${existingImage}`}
              style={{ height: 80, objectFit: "contain" }}
            />

            <button
              type="button"
              className="btn btn-sm btn-danger ms-2"
              onClick={() => {
                const ok = window.confirm(getText("CONFIRM_DELETE_IMAGE"));

                if (!ok) return;

                setExistingImage(null);
                setForm((prev) => ({ ...prev, delete_image: true }));
                toast.info(getText("IMAGE_MARKED_FOR_DELETE"));

              }}
            >
              {getText("DELETE")}

            </button>
          </div>
        )}

        <label className="form-label fw-bold mt-3">{getText("STATUS_LABEL")}</label>
        <select
          className="form-select mb-3"
          value={form.status}
          onChange={(e) => setForm({ ...form, status: e.target.value })}
        >
          <option value="aktif">{getText("STATUS_ACTIVE")}</option>
          <option value="pasif">{getText("STATUS_PASSIVE")}</option>
        </select>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary">{getText("SAVE")}</button>
        </div>
      </form>
    </div>
  );
};

export default BrandEdit;
